import { useAppContext } from '@prisjakt/ui-app-context';

import { MAX_RESULTS } from '../../constants';

import { Tab } from 'src/components/sticky-tab-nav/types';
import { TabAnchor, TabCounts } from './types';

export const UseNavigationTabs = (props: TabCounts): Tab[] => {
  const {
    brandsCount,
    categoriesCount,
    productsCount,
    storesCount,
    testsAndGuidesCount,
  } = props;

  const { market, t } = useAppContext();

  const formattedProductsCount =
    (productsCount || 0) >= MAX_RESULTS
      ? `${MAX_RESULTS.toLocaleString(market.localeStandard)}+`
      : (productsCount || 0).toLocaleString(market.localeStandard);

  return [
    ...[
      {
        id: TabAnchor.ALL,
        title: t('search', 'search.see-all-tab'),
      },
    ],
    ...(productsCount
      ? [
          {
            id: TabAnchor.PRODUCTS,
            title: `${t(
              'search',
              'products.title'
            )} (${formattedProductsCount})`,
          },
        ]
      : []),
    ...(categoriesCount
      ? [
          {
            id: TabAnchor.CATEGORIES,
            title: `${t(
              'search',
              'categories.title'
            )} (${categoriesCount.toLocaleString(market.localeStandard)})`,
          },
        ]
      : []),
    ...(testsAndGuidesCount
      ? [
          {
            id: TabAnchor.TESTS,
            title: `${t(
              'search',
              'tests.title'
            )} (${testsAndGuidesCount.toLocaleString(market.localeStandard)})`,
          },
        ]
      : []),
    ...(brandsCount
      ? [
          {
            id: TabAnchor.BRANDS,
            title: `${t(
              'search',
              'brands.title'
            )} (${brandsCount.toLocaleString(market.localeStandard)})`,
          },
        ]
      : []),
    ...(storesCount
      ? [
          {
            id: TabAnchor.STORES,
            title: `${t(
              'search',
              'stores.title'
            )} (${storesCount.toLocaleString(market.localeStandard)})`,
          },
        ]
      : []),
  ];
};
